import { FileClient, RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B070010FindRequest = Partial<{
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
  nyukaYmd: string;
  shireCd: string;
  juchudenpyoNo: string;
  hachudenpyoNo: string;
  shohinCd: string;
  janCd: string;
  itiranhyoji: string;
  nyukayoteilisthakozumiKbn: string;
  crtdayFrom: string;
  crthourFrom: string;
  crtminuteFrom: string;
  crtdayTo: string;
  crthourTo: string;
  crtminuteTo: string;
  juchuhinhasoYmdFrom: string;
  juchuhinhasoYmdTo: string;
  kakoshubetsuCd: string;
  shohinshubetsuKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B070010FindResponse = {
  nyukayoteisuGokei: string;
  shiresuGokei: string;
  nyukazansuGokei: string;
  nyukayotei: B070010DataDetailField[];
};

export type B070010DataDetailField = {
  juchudenpyoNo: string;
  juchugyoNo: string;
  juchudenpyoNoView: string;
  hachudenpyoNo: string;
  hachugyoNo: string;
  hachudenpyoNoView: string;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  nyukayoteiYmd: string;
  nyukaYmd: string;
  nyukayoteisu: string;
  shiresu: string;
  kafusokuRiyu: string;
  kakoshubetsuCd: string;
  kakoshubetsuNm: string;
  shainCd: string;
  shainNm: string;
};

//検索処理
export const B070010Find = (props: B070010FindRequest) => {
  return RestClient.get<PageableResponse<B070010FindResponse>>("b070010/find", {
    params: props,
  });
};

export type B070010ExcelRequest = Partial<{
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
  nyukaYmd: string;
  shireCd: string;
  juchudenpyoNo: string;
  hachudenpyoNo: string;
  shohinCd: string;
  janCd: string;
  itiranhyoji: string;
  nyukayoteilisthakozumiKbn: string;
  crtdayFrom: string;
  crthourFrom: string;
  crtminuteFrom: string;
  crtdayTo: string;
  crthourTo: string;
  crtminuteTo: string;
  juchuhinhasoYmdFrom: string;
  juchuhinhasoYmdTo: string;
  kakoshubetsuCd: string;
  shohinshubetsuKbn: string;
}>;

// Excel出力処理
export const B070010GetExcel = (props: B070010ExcelRequest) => {
  return FileClient.get("b070010/get/excel", {
    params: props,
  });
};
